"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTrackingCategory = void 0;

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Cameron Hassan
 */
var getTrackingCategory = function getTrackingCategory() {
  if (window.location.pathname.includes('leader/boards')) {
    return 'Leaderboards > Video > Play';
  }

  if (window.location.pathname.includes('traceid')) {
    return 'ID > Video > Play';
  }

  return 'GO > Video > Play';
};

exports.getTrackingCategory = getTrackingCategory;